import ThemeColors from "../../config/themeColors";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from "@fortawesome/free-solid-svg-icons";

const RefreshIcon = styled(FontAwesomeIcon)`
    position: absolute;
    top: -2rem;
    right: .8rem;
    font-size: 1.5rem;
    cursor: pointer;
    color: ${ThemeColors.ftgGrayBlue};
`;

interface Props {
    onClick: () => void;
}

const Refresh = ({onClick}: Props) => (
    <RefreshIcon onClick={onClick} icon={faRefresh} />
);

export default Refresh;